var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorrectFilledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "104px",
    viewBox: "0 0 104.0 104.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1920,0 L1920,1036 L0,1036 L0,0 L1920,0 Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i1",
    x: "-28.8461538%",
    y: "-28.8461538%",
    filterUnits: "userSpaceOnUse",
    width: "138.461538%",
    height: "138.461538%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "SourceAlpha",
    result: "i2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "i2",
    result: "i3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0.0 0 0 0 0 0.0 0 0 0 0 0.0 0 0 0 0 0.05233743307473776 0",
    type: "matrix",
    in: "i3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42,0 C65.1959595,0 84,18.8040405 84,42 C84,65.1959595 65.1959595,84 42,84 C18.8040405,84 0,65.1959595 0,42 C0,18.8040405 18.8040405,0 42,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2804978,0.372291259 C32.864509,-0.175047436 33.7769379,-0.102243171 34.287805,0.481488532 C34.7623398,1.02906836 34.7623398,1.83202687 34.2880595,2.45243703 L34.2516548,2.48884177 C32.3901962,4.60564646 30.5653646,6.8683725 28.8135914,9.16772552 C27.0981845,11.4669482 25.3828428,13.8027327 23.8136179,16.2115756 C22.7734852,17.7777845 21.5492494,19.8022302 20.3539077,21.8525386 L19.9776403,22.5003598 C17.6663113,26.4943391 15.5495811,30.4137997 15.2004126,31.065705 C14.6891991,32.0511793 13.8134754,33.0000266 12.2075584,33.0000266 C10.5652751,33.0000266 9.76232314,32.0145197 9.39725254,31.3941096 C9.22799279,31.089442 7.23759631,27.6527333 5.15163793,24.0545932 L4.56386427,23.0408075 C2.34460985,19.2133642 0.200101141,15.5180744 0.200101141,15.5180744 C-0.201374852,14.8248991 0.017539771,13.9488626 0.711040962,13.5473866 C1.29505225,13.1825767 2.02493277,13.3284524 2.46281415,13.8029869 L11.7329588,23.7665675 C14.2877231,20.1169043 17.0249705,16.5766006 19.8717079,13.1825441 C21.8060294,10.9198181 23.8134093,8.73015045 25.8571556,6.57665362 C27.937594,4.42341747 30.0177717,2.34323976 32.2804978,0.372291259 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-908.0 -355.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(542.0 275.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(376.0 90.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42,84 C65.1959595,84 84,65.1959595 84,42 C84,18.8040405 65.1959595,0 42,0 C18.8040405,0 0,18.8040405 0,42 C0,65.1959595 18.8040405,84 42,84 Z",
    stroke: "none",
    fill: "#000000",
    filter: "url(#i1)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 84,0 84,84 0,84 0,0",
    stroke: "none",
    fill: "#013B93"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.000000000001037 25.99999999999831)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1.11022302e-16,0 34.6437379,0 34.6437379,33.0000266 1.11022302e-16,33.0000266 1.11022302e-16,0",
    stroke: "none",
    fill: "#FFFFFF"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectFilledIcon);
export default __webpack_public_path__ + "static/media/correct-filled-icon.6c0a0973ad7e6d51c904674559351c9d.svg";
export { ForwardRef as ReactComponent };